import { Box, Typography, Paper, Tabs, Tab } from "@mui/material";
import { motion } from "framer-motion";
import VideoPlayer from "./VideoPlayer";

interface StreamViewerProps {
  streams: any[];
  activeStream: number;
  onStreamChange: (streamIndex: number) => void;
  memorialTheme: any;
  currentStream: any;
  deceasedName: string | undefined;
}

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1 },
};

export default function StreamViewer({
  streams,
  activeStream,
  onStreamChange,
  memorialTheme,
  currentStream,
  deceasedName,
}: StreamViewerProps) {
  console.log("type of service", currentStream.booking);
  return (
    <motion.div variants={itemVariants}>
      <Paper
        sx={{
          borderRadius: "15px",
          overflow: "hidden",
          backgroundColor: "transparent",
          width: "100%",
          boxShadow: 0,
        }}
      >
        {/* Stream Tabs Bar */}
        {streams && streams.length > 1 && (
          <Box
            sx={{
              backgroundColor: memorialTheme.primary,
              borderRadius: "15px 15px 0 0",
              mb: 2,
            }}
          >
            <Tabs
              value={activeStream}
              onChange={(event, newValue) => onStreamChange(newValue)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabs-scroller": {
                  // Hide scrollbar
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  msOverflowStyle: "none",
                  scrollbarWidth: "none",
                },
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontSize: "1rem",
                  color: "#ffffff",
                  "&.Mui-selected": {
                    color: "#000000",
                    fontWeight: "bold",
                  },
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "transparent",
                },
              }}
            >
              {streams.map((stream, index) => (
                <Tab
                  key={index}
                  label={stream.title || `Stream ${index + 1}`}
                  sx={{
                    color: activeStream === index ? "#000000" : "#FFFFFF",
                    backgroundColor:
                      activeStream === index ? "#FFFFFF" : "transparent",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      right: 0,
                      top: "25%",
                      height: "50%",
                      width: "1px",
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                    },
                    "&:last-child::after": {
                      display: "none",
                    },
                  }}
                />
              ))}
            </Tabs>
          </Box>
        )}

        {/* Main Content Area */}

        <Box sx={{ mb: 1 }}>
          {/* Main Title */}

          {/* Video Player */}
          <Box
            sx={{
              borderRadius: "20px",
              overflow: "hidden",
              width: "100%",
              "& .video-js": {
                borderRadius: "20px",
              },
            }}
          >
            <VideoPlayer streamData={currentStream} />
          </Box>
        </Box>
      </Paper>
    </motion.div>
  );
}
